import Win from './win';
import './style.css';
import Notify from 'skin/cmp/notify';

const Reset = ({ data }) => {
	let cls = ['skin-reset', 'reset-box'];
	cls = cls.join(' ');
	const stl = {
		backgroundImage: 'url(/task/img/pattern.png)',
		backgroundSize: 'cover',
	};
	return (
		<div className={cls} style={stl}>
			<div className="shadow"></div>
			<div className="container">
				<Win />
				<div className="phone">+7 (904) 408 94 94</div>
			</div>
			<Notify data={data.notify} />
		</div>
	);
};

export default Reset;
